<!--
 * @Author: Soul(佘家骏)
 * @Date: 2021-05-31 17:23:14
 * @LastEditors: soul(佘家骏) 
 * @LastEditTime: 2022-05-07 17:47:06
 * @Description: file content
 -->
<template>

  <!-- 滚动奖品列表 -->
  <div class="pay-layer" v-show="payList.length > 0">
    <div
      class="item"
      :class="{ anim: animate && index == 0 }"
      v-for="(item, index) in payList"
      :key="item.id"
    >
      <img :src="item.headImg" alt />
      <div class="text">
        {{ item.nickName | filterName }}已获得{{ item.prizeName }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      payList: [], // 滚动奖品列表
      animate: false, // 滚动奖品动画
    };
  },
  filters: {
    filterName: function (name) {
      if (name == null) {
        return name + "***";
      } else if (name && name.length >= 1) {
        return name.slice(0, 2) + "***";
      } else {
        return name + "***";
      }
    }
  },
  watch: {},
  computed: {},
  methods: {
    //滚动展示支付列表
    async getPaySuccess() {
      const data = await this.$httpdf.get(this.apiHost + 'secret/luckyUsers')
      if (data.code == 0) {
        this.payList = data.data;
        //滚动展示支付列表
      }
    },
    // 底部获奖列表滚动
    scroll() {
      this.animate = true;
      setTimeout(() => {
        this.payList.push(this.payList[0]);
        this.payList.shift();
        this.animate = false;
      }, 1000);
    },
  },
  created() {
   this.getPaySuccess()
    setInterval(this.scroll, 2000);
  },
  mounted() {}
};
</script>
<style lang="scss" scoped>
// 滚动奖品列表
.pay-layer {
  height: 80px;
  overflow: hidden;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 20px;
  z-index: 89;
  .item {
    height: 40px;
    list-style: none;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding-left: 25px;
    &.anim {
      transition: all 1s;
      margin-top: -40px;
    }
    > img {
      width: 30px;
      height: 30px;
      border-radius: 30px;
      display: block;
    }
    .text {
      line-height: 20px;
      padding: 5px 15px;
      border-radius: 25px;
      font-size: 12px;
      color: #fff;
      background: rgba(0, 0, 0, 0.5);
      margin-left: 10px;
      overflow: hidden; 
      text-overflow:ellipsis;
      white-space: nowrap;
    }
  }
}
</style>